import { Box, Typography } from "@mui/material";
import React from "react";
import { B } from "../B";

export function FaithPage() {
  return (
    <Box>
      <Typography variant="h1">Faith and Religion</Typography>{" "}
      <Typography>
        After creating the world, the ancient gods took a largely hands-off role
        in the continued development of cultures, and although they continued
        overseeing aspects of life and death, they did not interact with mortals
        aside from a few miraculous interventions. They became known as the
        Natural Pantheon.
        <B></B>Below them are the Civil Pantheon, Gods that oversee the more
        civilised parts of life. Created alongside the developing cultures of
        the world, these Gods wield lesser power than their forefathers, but are
        much more familiar with the mortals, offering more occasional
        appearances and influence on the world.
        <B></B>Every now and then a creature with god-like power walks the
        world, and are occasionally elevated to a godhood of sorts. Named the
        Rogue Gods, they have no implicit domain, and are much more self-serving
        and present in the world's affairs.
      </Typography>
      <Typography variant="h2">The Natural Pantheon</Typography>
      <Typography>
        Six Entities from far beyond, the Natural Pantheon created Santryl long
        ago.
      </Typography>
      <Typography variant="h4">God of Day, Crol'rim</Typography>
      <Typography>
        Crol'rim is perhaps the most trusted of the Natural Gods, His domain
        that of the Day, where most denizens spend their waking hours. He rarely
        interacts with mortals, but has been known to monitor those that worship
        and preach for His cause, making sure any disbelievers are punished for
        their lack of piety.
      </Typography>
      <Typography variant="h4">God of Death, Ish'per</Typography>
      <Typography>
        Next is Ish'Per, God of Death. Unlike Spri'eek, Ish'per waits, watching,
        curiously stalking those It will soon claim, and will regularly check up
        upon those who have passed through to another plane. Though It holds no
        domain in the physical plane, It is believed to influence events and
        delay deaths It deems unjust.
      </Typography>
      <Typography variant="h4">God of Entropy, Tual'ven</Typography>
      <Typography>
        All things come to a slow end, and Tual'ven is waiting there ready.
        Whilst Ish'per governs those whose physical form dies, Tual'ven watches
        for the moment that a concept, a memory, an ideal stops existing, the
        impetus removed from the world. It is said He collects these that fade
        away, but is loathe to share.
      </Typography>
      <Typography variant="h4">God of Life, Spri'eek</Typography>
      <Typography>
        Held in the highest regard by the denizens of Santryl, the God of Life
        Spri'eek oversees the bloom of life across the world. They tend to each
        new life with the utmost care, but then let it fend for itself once
        born. Life, the giving of it, is Their responsibility, and anything
        after does not concern Them.
      </Typography>
      <Typography variant="h4">God of Night, Den'wyt</Typography>
      <Typography>
        The God of Night, Den'wyt, is the most absent of Her Pantheon. The night
        comes with Her darkness, and She cares not to govern those that work
        beneath it, instead considering it a fitting challenge for mortals. Any
        who try, try on their own fortune, alone.
      </Typography>
      <Typography variant="h4">God of Planes, Zak'zar</Typography>
      <Typography>
        Zak'zar is the most present of the Natural Gods, for Their power is
        required each time planar travel is achieved. They are revered by the
        Gnomes of Gnome Island, and those wise enough to ask Their blessing when
        travelling through. Zak'zar care not, really, who travels, unless they
        intend on travelling to Their palace, but those are few who know or try
        such a feat.
      </Typography>
      <Typography variant="h2">The Civic Pantheon</Typography>
      <Typography variant="h4">God of Bargains, Deel</Typography>
      <Typography>
        With his name almost becoming synonymous with trades and deals, Deel
        watches over every bargain and agreement made between mortals. From
        gambling agreements to wedding vows, Deel ensures either side pays up or
        serves the consequences. For obvious reasons he can't actually attend
        every follow up, but he appears often enough to hold respect in the
        mortals' minds.
      </Typography>
      <Typography variant="h4">God of Disaster, Ohn</Typography>
      <Typography>
        Ohn oversees the prevention and allowance of natural disasters. Storms,
        eruptions, quakes, all must be given a chance to occur, and whilst Ohn
        does not hold malice for those afflicted, there may be a bias as to
        which are more deserving of the ensuing chaos.
      </Typography>
      <Typography variant="h4">God of Home, Chelt</Typography>
      <Typography>
        No matter the size of the abode, if someone cares for it, Chelt makes it
        a home. Certain protections are afforded those in their homes, such as a
        minor defence against vampiric beings, and a quiet trust that the storms
        won't break through in the night.
      </Typography>
      <Typography variant="h4">God of Justice, Scayl</Typography>
      <Typography>
        Where Deel ensures bargains are upheld, Scayl looks to make sure they
        are fair, or justified in being unfair. From reparations, to punishment,
        Scayl sees prisoner and warmonger alike.
      </Typography>
      <Typography variant="h4">God of Roads, Pave</Typography>
      <Typography>
        Pave is the god of travel, roads, and in-betweens. Any passage is his
        domain, as are straits, fords, bridges, and tunnels. He makes sure no
        monsters lurk too near to the major routes, and aids those accosted upon
        them.
      </Typography>
      <Typography variant="h4">God of Seas, Bow'Tee</Typography>
      <Typography>
        Upon the waves, sailors find little respite, as Bow'Tee cares more for
        the monsters than they do the more civilised creatures. Large beasts
        roam the oceans, feeding on those unfortunate enough to fall in. Luckily
        for sailors, Pave ensures that Bow'Tee does not go too far in sinking
        ships.
      </Typography>
      <Typography variant="h4">God of War, Agres</Typography>
      <Typography>
        Since creatures have had thoughts of self, they have had thoughts of
        war. Agres watches over, regulates, and often incites violence between
        factions on Santryl.
      </Typography>
      <Typography variant="h2">The Rogue Gods</Typography>
      <Typography>
        Mortals that attained god-like powers, or enacted forbidden rituals to
        attain godhood, the Rogue Gods each have their own agenda.
      </Typography>
      <Typography variant="h4">Kinnos, Machine Spirit</Typography>
      <Typography>
        Manifested by fanatical belief in Gallia, Kinnos is the source of any
        and all autonomous mechanical marvels. From robotic underlings to
        vehicles of war, Kinnos is their. Despite claims from their followers,
        it is unclear if Kinnos supports the aggressive use of machines, their
        signs being mostly apathetic if asked.
      </Typography>
      <Typography variant="h4">The Platinum Lady</Typography>
      <Typography>
        Progenitor of the Dragonborn, the Platinum Lady came from the cosmos,
        landing aeons ago in a comet. Now she wields power matching that of
        higher gods, she seeks mainly to maintain whatever order she finds upon
        her lands.
      </Typography>
      <Typography variant="h4">Rat Master Onchus</Typography>
      <Typography>
        Born from the festering filth of Gallia's underground sewage systems,
        Onchus was a Rat King that ascended mortality after reaching a size too
        large to sustain. His favourite blessings include toxic deluges and
        hordes of vermin. His offspring, the Ratfolk, lay in wait in the
        shadows, committing acts of violence and watching the blame get placed
        on the Goblins.
      </Typography>
      <Typography variant="h2">The Giants</Typography>
      <Typography>
        Though not gods themselves, the giants were granted magic and power from
        their creators, that they could supervise the development of Santryl.
        Many giants have chosen to leave the living behind, but a few remain
        vigilant and watchful.
      </Typography>
      <Typography variant="h4">Olgrath</Typography>
      <Typography>
        Hidden away in the hot springs known as Olgrath's Baths, Olgrath has a
        particular attachment to the natural state, and casts her influence to
        maintain the health of the various foliage in Santryl. Knowing that her
        life would be threatened if her location was common knowledge, she hides
        deep within the Croaking Conclave, and trusts them with tasks to help
        restore balance where it is needed.
      </Typography>
    </Box>
  );
}
